export const useServiceManagement = (wizardData, setWizardData) => {
  const updateItemHours = (si, ii, hours) => {
    const s = [...wizardData.services];
    s[si].items[ii].hours = parseFloat(hours) || 0;
    setWizardData({ ...wizardData, services: s });
  };

  const updateItemRole = (si, ii, role) => {
    const s = [...wizardData.services];
    s[si].items[ii].role = role;
    setWizardData({ ...wizardData, services: s });
  };

  const updateItemNotes = (si, ii, notes) => {
    const s = [...wizardData.services];
    s[si].items[ii].notes = notes;
    setWizardData({ ...wizardData, services: s });
  };

  const addLineItem = (si) => {
    const s = [...wizardData.services];
    s[si].items.push({ role: 'Acct Mgr', hours: 0, notes: '' });
    setWizardData({ ...wizardData, services: s });
  };

  const removeLineItem = (si, ii) => {
    const s = [...wizardData.services];
    s[si].items.splice(ii, 1);
    setWizardData({ ...wizardData, services: s });
  };

  const addService = () => {
    setWizardData({
      ...wizardData,
      services: [...wizardData.services, { name: 'New Service', items: [{ role: 'Acct Mgr', hours: 0, notes: '' }] }],
    });
  };

  const updateServiceName = (si, name) => {
    const s = [...wizardData.services];
    s[si].name = name;
    setWizardData({ ...wizardData, services: s });
  };

  return {
    updateItemHours,
    updateItemRole,
    updateItemNotes,
    addLineItem,
    removeLineItem,
    addService,
    updateServiceName,
  };
};